const comments = [
  {
    name: '电影爱好者小林',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20portrait%20silhouette%20with%20soft%20golden%20light%2C%20artistic%20minimalist%20style%2C%20elegant%20simple%20composition&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '用了丫丫影院快半年了，真心觉得是最新电影不缓冲做得最好的平台之一。以前在其他网站看新片总是卡，这里流畅播放体验好太多，高清免费看真的良心！',
    date: '2026年7月30日',
  },
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20portrait%20silhouette%20with%20coral%20and%20amber%20tones%2C%20artistic%20minimalist%20style%2C%20soft%20elegant%20composition&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '最新电视剧流畅不缓冲在线看这点真的绝了，追韩剧从来没卡过。而且最新更新特别及时，基本同步播出，不用到处找资源了，丫丫影院一个站全搞定。',
    date: '2026年7月28日',
  },
  {
    name: '深夜刷片人',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20portrait%20silhouette%20with%20soft%20golden%20lighting%2C%20artistic%20minimalist%20style%2C%20elegant%20dark%20background%20composition&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '在线观看体验真不错，资源很全，从经典老片到院线新片都能找到。画质清晰度高，不缓冲在线看特别适合晚上窝在沙发里追片。推荐给所有爱看电影和电视剧的朋友！',
    date: '2026年7月25日',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[960px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              影迷心声
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              来自真实用户的使用感受，听听他们怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {comments.map((c, idx) => (
              <div
                key={idx}
                className="p-5 rounded-xl bg-background-50 border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={c.avatar}
                      alt={c.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-900">{c.name}</div>
                    <div className="text-xs text-foreground-400">{c.date}</div>
                  </div>
                </div>
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}